// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"0861ae9182bbc23e0885","655":"565ea71caedb943fb818"}[chunkId] + ".js";
};